import React from 'react';
import { NodeProps } from 'reactflow';
import styled from 'styled-components/macro';
import { ReactComponent as Braille } from '../../../images/icons/braille-solid.svg';
import { colourYellow09, colourYellow10 } from '../../../styling/colours';
import { getFlowRateString } from '../../shared/quote-or-design-form/map/map-helpers/mapHelpers';
import { ManifoldMapNodeData } from '../../shared/quote-or-design-form/map/mapNode';
import { getManifoldDisplayName } from '../helpers/manifoldHelpers';
import { MapFlowNodeReadOnly } from './MapFlowNodeReadOnly';
import { usePdfStaticReferenceData } from './usePdfStaticReferenceData';

export const ReadOnlyManifold = ({
  data: { flowRateInLitresPerMinute, pumpOnManifold, manifoldIndex },
}: NodeProps<ManifoldMapNodeData>) => {
  const { manifolds } = usePdfStaticReferenceData();
  const flowRate = getFlowRateString(flowRateInLitresPerMinute, null);
  const stats = [...(pumpOnManifold ? ['With PM1W/2-A'] : []), flowRate];
  const manifoldName = manifoldIndex != null ? getManifoldDisplayName(manifolds[manifoldIndex].name) : '';

  return (
    <ManifoldFlowNode icon={<ManifoldIcon />} stats={stats} hasSource={false} hasTarget={true} title={manifoldName} />
  );
};

const ManifoldIcon = styled(Braille)`
  height: 1em;
  width: 1em;
`;

const ManifoldFlowNode = styled(MapFlowNodeReadOnly)`
  border-color: ${colourYellow09};
  background: ${colourYellow10};
`;
